module.exports = __webpack_public_path__ + "media/images/icons/outlined/vertical-left-9fa03f646ac9a8fe3565dd9374a372bc.svg";